/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-statements */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-unneeded-ternary */
import { call, takeLatest, putResolve, put, select, delay } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  setLoginModalMountedState,
  setExistingUserResponse,
  setEmailRetryCount,
  setMaskedPhoneNumber,
  setShowPhoneLoginOption,
  setShowOTPInputScreen,
  setOTPToken,
  setUserNotExist,
  setLoginSelectedOption,
  setPlccLoginLoadingState,
  setIsOtpLimit,
  showEmailFormScreen,
  setIsLocked,
  setCountryCode,
} from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.actions';
import { trackError } from '@tcp/core/src/utils/errorReporter.util';
import injectCouponDynamicStore from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/CouponDynamicStore';
import {
  getIsMuleLogonApiEnable,
  getIsNewPegaDigitalChatEnabled,
  getIsGuestFavAppEnabled,
  getPlccICForRememberedUserEnabled,
  getIsOTpScreenEnabled,
  getIsInternationalShipping,
  getIsHideLoginLoader,
  getIsBriteVerifyForLoginEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { setClickAnalyticsData, trackClick, trackFormError } from '@tcp/core/src/analytics/actions';
import {
  updateMiniBagFlag,
  resetCartCache,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import { removeSessionStorage, routerReplace, getSessionStorage } from '@tcp/core/src/utils';
import utility from '@tcp/core/src/components/features/CnC/Checkout/util/utility.js';
import { md5 } from '@tcp/core/src/utils/encoding';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import { CHECKOUT_ROUTES } from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import { setContactFormValuesInSS } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import {
  addItemsToWishlist,
  setPendingAddWishlistProduct,
} from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.actions';
import { getPendingAddWishlistProduct } from '@tcp/core/src/components/features/browse/Favorites/container/Favorites.selectors';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';

import LOGINPAGE_CONSTANTS from '../LoginPage.constants';
import names from '../../../../../constants/eventsName.constants';
import {
  setLoginInfo,
  setCheckoutModalMountedState,
  setLoginLoadingState,
} from './LoginPage.actions';
import { logout } from '../../Logout/container/LogOut.actions';
import { navigateXHRAction } from '../../NavigateXHR/container/NavigateXHR.action';
import { getUserInfoSaga } from '../../User/container/User.saga';
import fetchData from '../../../../../service/API';
import {
  login,
  emailVerify,
  generateLoginOTP,
} from '../../../../../services/abstractors/account/Login';
import { getUserSelectionApi } from '../../../../../services/abstractors/productListing/userbrowsehistory';
import endpoints from '../../../../../service/endpoint';
import { resetPassword } from '../../ForgotPassword/container/ForgotPassword.actions';
import { routerPush, scrollPage, WebViewRedirectURL } from '../../../../../utils';
import {
  checkoutModalOpenState,
  getAccountCardVisibility,
  getIsLoginWithOTPEnabled,
  getOTPToken,
} from './LoginPage.selectors';
import {
  getplccCardId,
  getUserId,
  getUserEmail,
  getUserLoggedInState,
} from '../../User/container/User.selectors';
import { CONTACT_FORM } from '../../../CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.constant';
import BAG_PAGE_ACTIONS from '../../../CnC/BagPage/container/BagPage.actions.js';
import { openAccountDrawer } from '../../../../common/organisms/Header/container/Header.actions';
import { getIsFromCreateAccountFlow } from '../../CreateAccount/container/CreateAccount.selectors';
import { setShowVerificationError } from '../../CreateAccount/container/CreateAccount.actions';

import { getMyRewardCouponList } from '../../../CnC/common/organism/CouponAndPromos/container/Coupon.actions.js';
import { setResetPassCountryCode } from '../../ResetPassword/container/ResetPassword.actions';
import briteVerifyStatusExtraction from '../../../../../services/abstractors/common/briteVerifyStatusExtraction';

const notIsLocalHost = (siteOrigin) => {
  return siteOrigin.indexOf('local') === -1;
};

function setEmailDataInStorage(userEmail) {
  const emailHash = userEmail ? md5(userEmail.toUpperCase()) : null;
  if (emailHash) {
    setLocalStorage({ key: 'email_hash', value: emailHash });
    /* eslint no-underscore-dangle: 0 */
    if (window && window._dataLayer) window._dataLayer.email_hash = emailHash;
  }
}
const isLoginCheckoutFlow = () => {
  return window?.location?.href?.includes('login-checkout');
};

const isLoginFlow = () => {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  return window?.location?.href?.includes('/home/login');
};

const isRegisterFlow = () => {
  return (
    window?.location?.href?.includes('register-checkout?from=SA') ||
    window?.location?.href?.includes('/register')
  );
};

const isRegisterCheckoutFlow = () => {
  return window?.location?.href?.includes('register-checkout') && !isRegisterFlow();
};

const isBagPageFlow = () => {
  return window?.location?.href?.includes('bag');
};

const getCustomDimension = () => {
  return isLoginCheckoutFlow() ? 'Checkout' : 'Standalone';
};

const getAdobeCustomDimension = () => {
  return isLoginCheckoutFlow() ? 'Checkout' : 'Standalone';
};

export function* fireAnalyticsEvent({ triggerPath, isSuccess, err, isGenerateOTP = false }) {
  let pageName = '';
  const eventName = names.screenNames.login_success;
  pageName = window && window.loyaltyLocation;
  const customDimension = getCustomDimension();
  const AdobeCustomDimension = getAdobeCustomDimension();

  let events = [];
  let eventData = {};

  if (
    (isLoginCheckoutFlow() || AdobeCustomDimension === 'Checkout') &&
    !isGenerateOTP &&
    isSuccess
  ) {
    events = ['event35'];
    eventData = { metric35: '1' };
  }

  let cd = { login_path_cd123: `${customDimension}|${triggerPath}|Success` };

  if (!isSuccess) {
    // API failure
    const { errorCode, errorMessage } = err?.errorResponse?.errors?.[0] || err?.errors?.[0] || {};
    events = ['event44'];

    cd = {
      login_path_cd123: `${customDimension}|${triggerPath}|Failure|${errorCode}-${errorMessage}`,
    };
  }

  if (isGenerateOTP) {
    // log it for both success & failure
    events = ['event44'];

    pushEventToAdobeAnalytics('otp_generate_success', cd);
  }

  yield put(
    setClickAnalyticsData({
      ...eventData,
      eventName: 'login',
      customEvents: isSuccess && !isGenerateOTP ? ['event14', 'event128', ...events] : [...events],
      pageNavigationText: `${pageName || ''}-log in`,
      clickEvent: true,
      loyaltyLocation: pageName,
      ...cd,
    })
  );
  yield put(trackClick({ name: eventName, module: 'account' }));
}
export function adobeAnalyticsLoginPath({ triggerPath, isSuccess, err }) {
  const customDimension = getAdobeCustomDimension();
  let loginPathCd123 = `${customDimension}|${triggerPath}|Success`;
  if (!isSuccess) {
    // API failure
    const { errorCode, errorMessage } = err?.errorResponse?.errors?.[0] || err?.errors?.[0] || {};

    loginPathCd123 = `${customDimension}|${triggerPath}|Failure|${errorCode}-${errorMessage}`;
  }
  return loginPathCd123;
}
function* fireAnalytics() {
  const pageName = window && window.loyaltyLocation;
  let events = [];
  let eventData = {};
  if (isLoginCheckoutFlow()) {
    events = ['event35'];
    eventData = { metric35: '1' };
  }
  yield put(
    setClickAnalyticsData({
      ...eventData,
      eventName: 'login',
      customEvents: ['event14', 'event128', ...events],
      pageNavigationText: `${pageName || ''}-log in`,
      clickEvent: true,
      loyaltyLocation: pageName,
    })
  );
  yield put(trackClick({ name: names.screenNames.login_success, module: 'account' }));
}

function redirectWebView(webView, isMergeAccount) {
  return webView || isMergeAccount;
}

function isOpenOverlayModal(
  afterLoginHandler,
  fullPage,
  isAccountCardVisible,
  isApplyPlccCardFlow
) {
  return (
    (!afterLoginHandler || fullPage) &&
    isAccountCardVisible &&
    !isApplyPlccCardFlow &&
    !isLoginCheckoutFlow()
  );
}

// eslint-disable-next-line complexity
export function* loginSaga({ payload, afterLoginHandler, fromPlcc }) {
  yield put(setLoginLoadingState({ isLoading: true }));
  yield put(setPlccLoginLoadingState(true));
  const isOTPSelected = typeof payload.otp !== 'undefined' && payload.otp;
  let triggerPath = 'Login With Password';
  if (isOTPSelected) {
    triggerPath = 'Login With OTP';
  }
  const {
    isApplyPlccCardFlow,
    changePasswordRequest,
    isResetFromCheckout = false,
    fromPlccICLogin,
    fromCreateAccount = false,
  } = payload;
  const isLoginWithOTPEnabled = fromPlccICLogin ? true : yield select(getIsLoginWithOTPEnabled);
  const isHideLoginLoader = yield select(getIsHideLoginLoader);
  try {
    const plccCardId = yield select(getplccCardId);
    const userId = yield select(getUserId);
    const isAccountCardVisible = yield select(getAccountCardVisibility);
    const updatedPayload =
      plccCardId && payload.plcc_checkbox ? { ...payload, plccCardId } : payload;
    updatedPayload.userId = userId;
    const { fullPage } = payload;
    const isMuleLogonApiEnabled = yield select(getIsMuleLogonApiEnable);
    let response;
    const isMuleLoginReq = isMuleLogonApiEnabled && !changePasswordRequest;
    const isGuestFavAppEnabled = yield select(getIsGuestFavAppEnabled);
    const guestFavAppCheck = isGuestFavAppEnabled ? isGuestFavAppEnabled : true;
    const isOTpScreenEnabled = yield select(getIsOTpScreenEnabled);
    const isFromCreateAccountFlow = yield select(getIsFromCreateAccountFlow);

    if (isMuleLoginReq) {
      response = yield call(login, updatedPayload);
    } else {
      response = { success: true };
    }
    if (response && response.success) {
      try {
        yield call(login, {
          ...updatedPayload,
          useSFCCAPI: true,
          isSfccPlatform: !isMuleLogonApiEnabled,
          isOTpScreenEnabled,
          isFromCreateAccountFlow,
        });

        getUserSelectionApi({ isLogin: true });
      } catch (err) {
        if (err?.errorCode === 'USER_ALREADY_PRESENT') {
          const resetPasswordPayload = { logonId: payload?.emailAddress, isFromLogin: true };
          yield put(resetPassword(resetPasswordPayload));
        }
        if (!isLoginCheckoutFlow() && isMuleLoginReq) {
          yield put(logout({}));
        }
        logger.error({
          error: `Exception in sfccLogon API Call: ${JSON.stringify(err)}`,
          payload,
        });
        throw err;
      }
      yield put(resetCartCache());
      const isPendingWishlistedProduct = yield select(getPendingAddWishlistProduct);

      yield call(getUserInfoSaga, {
        payload: {
          loadFavStore: true,
          ignoreCache: true,
          apiSuccess: true,
          refresh: true,
          isPendingWishlistedProduct,
          isCalledFromLoginSaga: true,
        },
      });
      if (afterLoginHandler) {
        yield call(afterLoginHandler);
      }
      yield put(setLoginModalMountedState({ state: false, isAccountCardVisible }));
      if (isHideLoginLoader) yield put(setLoginLoadingState({ isLoading: false }));
      if (
        window?.location?.href?.includes('from=SA') ||
        !window?.location?.href?.includes('-checkout')
      ) {
        yield put(navigateXHRAction());
      }
      yield delay(100);
      if (
        isOpenOverlayModal(
          afterLoginHandler,
          fullPage,
          isAccountCardVisible,
          isApplyPlccCardFlow
        ) &&
        !isBagPageFlow() &&
        !isResetFromCheckout &&
        !window?.location?.href?.includes('register-checkout')
      ) {
        yield delay(100);
        yield put(openAccountDrawer());
      }
      const userEmail = yield select(getUserEmail);
      const loggedInState = yield select(getUserLoggedInState);
      const customerID = yield select(getUserId);
      const userEmailId = yield select(getUserEmail);
      removeSessionStorage('SFL_ID');
      setEmailDataInStorage(userEmail);
      if (!fromCreateAccount) {
        removeSessionStorage('isNewlyCreatedUser');
      }
      window?.localStorage?.removeItem('isApplyNowModalShown');
      yield put(updateMiniBagFlag(true));
      const isNewPegaDigitalChatEnabled = yield select(getIsNewPegaDigitalChatEnabled);
      if (
        isNewPegaDigitalChatEnabled &&
        window &&
        window.PegaChatTags &&
        typeof window.PegaChatTags === 'object' &&
        window.PegaChatTags !== null
      ) {
        const { emailAddress = '' } = payload || {};
        window.PegaChatTags.CustomerScore = emailAddress;
        window.PegaChatTags.EncryptEmail = readCookie('tcpSessionInfo') || '';
        window.PegaChatTags.ContactId = emailAddress;
        window.PegaChatTags.ContactName = emailAddress;
      }
      if (window.location.href.includes('customer-help')) {
        const isMergeAccount = window.location.href.includes('account-and-coupons');
        const webView = JSON.parse(readCookie('fromMobileApp')) || false;
        if (redirectWebView(webView, isMergeAccount)) {
          WebViewRedirectURL();
        } else {
          routerPush('/', '/home');
        }
        scrollPage();
      }
      const plccICForRememberedUserEnabled = yield select(getPlccICForRememberedUserEnabled);
      if (fromPlccICLogin && plccICForRememberedUserEnabled) {
        yield put(BAG_PAGE_ACTIONS.startPlccCheckout({ fromPlccICLogin, fromLoginModal: true }));
      }
      if (isLoginCheckoutFlow()) {
        const IsInternationalShipping = yield select(getIsInternationalShipping);
        if (IsInternationalShipping) {
          utility.routeToPage(CHECKOUT_ROUTES?.internationalCheckout);
        } else {
          routerReplace(
            CHECKOUT_ROUTES?.singlePageCheckoutPage?.to,
            CHECKOUT_ROUTES?.singlePageCheckoutPage?.asPath
          );
        }
      }
      const loginPath = adobeAnalyticsLoginPath({
        triggerPath,
        payload,
        isSuccess: true,
      });
      window.sessionStorage.setItem(
        'user_info',
        JSON.stringify({ email: userEmailId, userID: customerID })
      );
      pushEventToAdobeAnalytics('login_success', {
        userEmailId,
        customerID,
        loggedInState,
        loginPath,
      });
      if (afterLoginHandler && fromPlcc) {
        yield injectCouponDynamicStore();
        yield put(getMyRewardCouponList({ ignoreCache: true, fromPlcc: true }));
      }
      if (isLoginWithOTPEnabled) {
        yield call(fireAnalyticsEvent, { triggerPath, payload, isSuccess: true });
      } else {
        yield call(fireAnalytics);
      }
    }
    if (isHideLoginLoader) yield put(setLoginLoadingState({ isLoading: false }));
    //* ***On Succesfull login add pending wishlisted product to default wishlist if any*** */
    const pendingWishlistedProduct = yield select(getPendingAddWishlistProduct);
    if (pendingWishlistedProduct && guestFavAppCheck) {
      yield put(
        addItemsToWishlist({
          ...pendingWishlistedProduct,
        })
      );
      yield put(setPendingAddWishlistProduct(null));
    }
    return yield putResolve(setLoginInfo(response));
  } catch (err) {
    yield put(setPlccLoginLoadingState(false));
    if (isLoginWithOTPEnabled) {
      yield call(fireAnalyticsEvent, { triggerPath, isSuccess: false, err });
    } else {
      const { emailAddress } = payload;
      yield put(trackFormError({ formName: 'LoginForm', formData: { emailAddress } }));
      trackError({
        error: err,
        extraData: {
          component: 'LoginPage - Saga',
          payloadRecieved: { emailAddress },
        },
      });
    }

    if (isHideLoginLoader) yield put(setLoginLoadingState({ isLoading: false }));
    const { errorCode, errorMessage, errorResponse, networkStatusCode, status, response } = err;

    const error = response?.body?.errors?.[0] || {};
    const { errorCode: errCode, errorMessage: errMsg } = error || {};

    if (networkStatusCode === 200) {
      yield put(
        setLoginInfo({
          success: false,
          ...errorResponse,
          errorCode,
          errorMessage,
          networkStatusCode,
        })
      );
      const isCheckoutModalOpen = yield select(checkoutModalOpenState);
      if (isCheckoutModalOpen) {
        yield put(setCheckoutModalMountedState({ state: true }));
      }
    } else {
      yield put(
        setLoginInfo({
          success: false,
          status,
          errorCode: errCode,
          errorMessage: errMsg,
        })
      );
    }
    const loginPath = adobeAnalyticsLoginPath({ triggerPath, isSuccess: false, err });
    const errForAA = 'form error:login';
    pushEventToAdobeAnalytics('login_fail', { errForAA, loginPath });

    return null;
  } finally {
    yield put(setLoginLoadingState({ isLoading: false }));
  }
}

// eslint-disable-next-line complexity
export function* emailSubmitSaga({ payload }) {
  yield put(setLoginLoadingState({ isLoading: true }));
  const isOTpScreenEnabled = yield select(getIsOTpScreenEnabled);
  const isBriteVerifyForLoginEnabled = yield select(getIsBriteVerifyForLoginEnabled);

  try {
    yield put(setResetPassCountryCode(null));
    const response = yield call(emailVerify, payload);
    if (
      isLoginCheckoutFlow() &&
      response?.status === 'fail' &&
      response?.error?.errorCode === '_ERR_INVALID_EMAIL_DOMAIN'
    ) {
      yield put(
        setLoginInfo({
          success: false,
          status: 'fail',
          errorCode: '_ERR_INVALID_EMAIL_DOMAIN',
        })
      );

      yield put(setLoginLoadingState({ isLoading: false }));
      return;
    }

    if (
      isBriteVerifyForLoginEnabled &&
      response?.status === 'fail' &&
      response?.error?.errorCode === 'EMAIL_DOES_NOT_EXIST'
    ) {
      const statusCode = yield call(briteVerifyStatusExtraction, payload.emailAddress);
      if (statusCode && statusCode.indexOf('invalid') !== -1) {
        yield put(
          setLoginInfo({
            success: false,
            status: 'fail',
            errorCode: '_ERR_INVALID_EMAIL_DOMAIN',
          })
        );

        yield put(setLoginLoadingState({ isLoading: false }));
        return;
      }
    }

    const {
      emailAddress,
      isExistingUser = false,
      phoneNumber,
      token,
      vstatus,
      locked,
      otpLimit,
      lockTime,
      phoneCountryCode,
    } = response || {};
    yield put(setCountryCode(phoneCountryCode));
    if (isOTpScreenEnabled) {
      yield put(setOTPToken(token));
      yield put(setExistingUserResponse(response));
      yield put(setIsOtpLimit(otpLimit));
      yield put(setIsLocked(locked));
      yield put(setShowVerificationError(false));
    }
    if (!(response?.status === 'fail' && response?.error?.errorCode === '_ERR_INVALID_EMAIL')) {
      setContactFormValuesInSS({
        emailAddress,
        isExistingUser,
        phoneNumber: phoneNumber || '',
        isShowPhoneLoginOption: typeof phoneNumber !== 'undefined' && phoneNumber ? true : false,
        token: token || '',
        vstatus,
        locked,
        otpLimit,
        lockTime,
        phoneCountryCode,
      });
    } else {
      yield put(
        setLoginInfo({
          success: false,
          status: response?.status,
          errorCode: response?.error?.errorCode,
        })
      );
    }
    if (
      response?.status === 'fail' &&
      isOTpScreenEnabled &&
      response?.error?.errorCode === '.MULTIPLE_OTP_ATTEMPT'
    ) {
      yield put(showEmailFormScreen(true));
      yield put(
        setLoginInfo({
          success: false,
          status: response?.status,
          errorCode: response?.error?.errorCode,
        })
      );
    } else {
      yield put(showEmailFormScreen(false));
    }

    const isLoginWithOTPEnabled = yield select(getIsLoginWithOTPEnabled);
    if (
      isLoginWithOTPEnabled &&
      response?.error?.errorCode === 'EMAIL_DOES_NOT_EXIST' &&
      !isLoginCheckoutFlow()
    ) {
      yield put(setUserNotExist(true));
    }

    yield put(setExistingUserResponse(response));
    const emailRetry = response?.error?.emailRetry;
    if (emailRetry) {
      yield put(setEmailRetryCount(emailRetry));
    } else {
      yield put(setEmailRetryCount(-1));
    }
    if (isOTpScreenEnabled) {
      yield put(setOTPToken(token));
    }
    if (isLoginWithOTPEnabled) {
      yield put(setOTPToken(token));
      if (typeof phoneNumber !== 'undefined' && phoneNumber) {
        yield put(setShowPhoneLoginOption(true));
        yield put(setMaskedPhoneNumber(phoneNumber));
      } else {
        yield put(setShowPhoneLoginOption(false));
        yield put(setMaskedPhoneNumber(''));
      }
    }
  } catch (err) {
    logger.error({
      error: `Exception in API Call: ${JSON.stringify(err)}`,
      payload,
    });
    throw err;
  } finally {
    yield put(setLoginLoadingState({ isLoading: false }));
  }
}

function* getOrderDetailSaga() {
  try {
    const { relURI, method } = endpoints.getOrderDetails;
    const siteOrigin = window && window.location && window.location.origin;
    const baseURI = notIsLocalHost(siteOrigin)
      ? siteOrigin
      : endpoints.getOrderDetails.baseURI || endpoints.global.baseURI;

    const res = yield call(
      fetchData,
      baseURI,
      relURI,
      {
        langId: -1,
        catalogId: 10551,
        storeId: 10151,
        pageName: 'fullOrderInfo',
        poc: 'withCredentials',
      },
      method
    );
    yield put(setLoginInfo(res.body));
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'LoginPage - Saga - getOrderDetailSaga',
      },
    });
  }
}

export function* loginSFCCSaga({ payload }) {
  try {
    yield call(login, payload);
  } catch (err) {
    logger.error({
      error: `Exception in sfccLogon API Call: ${JSON.stringify(err)}`,
      payload,
    });
  }
}

export function* generateLoginOTPSaga({ payload }) {
  const triggerPath = 'Login With OTP|Generate OTP';
  const isFromCreateAccountFlow = yield select(getIsFromCreateAccountFlow);
  yield put(setLoginLoadingState({ isLoading: true }));
  try {
    const otpToken = yield select(getOTPToken);
    const isOTpScreenEnabled = yield select(getIsOTpScreenEnabled);
    const reqPayload = payload || {};
    reqPayload.otpToken = otpToken;
    let savedContactFormData = getSessionStorage(CONTACT_FORM);
    savedContactFormData =
      (savedContactFormData &&
        savedContactFormData !== 'undefined' &&
        JSON.parse(savedContactFormData)) ||
      {};
    const tokenFromSessionStorage = savedContactFormData?.token;
    reqPayload.otpToken = reqPayload.otpToken || tokenFromSessionStorage || reqPayload.token;
    const response = yield call(
      generateLoginOTP,
      reqPayload,
      isOTpScreenEnabled,
      isFromCreateAccountFlow
    );
    if (response && response.success) {
      yield put(setLoginSelectedOption(payload.otpChannel));
      if (!isFromCreateAccountFlow) {
        yield put(setShowOTPInputScreen(true));
      }
      yield call(fireAnalyticsEvent, {
        triggerPath,
        isSuccess: true,
        response,
        payload,
        isGenerateOTP: true,
      });
    } else {
      yield call(fireAnalyticsEvent, {
        triggerPath,
        isSuccess: false,
        response,
        isGenerateOTP: true,
      });
    }
    return yield putResolve(setLoginInfo(response));
  } catch (err) {
    const { errorCode, errorMessage, errorResponse, networkStatusCode } = err;
    if (errorCode === '.EMAIL_VERIFICATION_EXPIRED') {
      yield put(setExistingUserResponse(''));
      removeSessionStorage(CONTACT_FORM);
      setContactFormValuesInSS();
      if (isLoginCheckoutFlow() || isRegisterCheckoutFlow()) {
        routerPush('/login-checkout', '/login-checkout');
      }
      if (isRegisterFlow()) {
        routerPush('/home/login', '/home/login');
      }
      if (isLoginFlow() || isLoginCheckoutFlow()) {
        yield put(setShowOTPInputScreen(false));
      }
    }
    yield put(
      setLoginInfo({
        success: false,
        ...errorResponse,
        errorCode,
        errorMessage,
        networkStatusCode,
      })
    );
    yield call(fireAnalyticsEvent, {
      triggerPath,
      payload,
      isSuccess: false,
      err,
      isGenerateOTP: true,
    });
    return null;
  } finally {
    yield put(setLoginLoadingState({ isLoading: false }));
  }
}
export function* LoginPageSaga() {
  yield takeLatest(LOGINPAGE_CONSTANTS.LOGIN, loginSaga);
  yield takeLatest('GET_ORDER_DETAIL', getOrderDetailSaga);
  yield takeLatest(LOGINPAGE_CONSTANTS.LOGIN_SFCC, loginSFCCSaga);
  yield takeLatest(LOGINPAGE_CONSTANTS.EMAIL_SUBMIT, emailSubmitSaga);
  yield takeLatest(LOGINPAGE_CONSTANTS.GENERATE_LOGIN_OTP, generateLoginOTPSaga);
}

export default LoginPageSaga;
